import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getSongLibraries,
  getSongLibrary,
  createSongLibrary,
  updateSongLibrary,
  deleteSongLibrary,
  importSongLibraryCsv
} from "../../helpers/songLibrary_helper";

export const fetchSongLibraries = createAsyncThunk(
  'songLibrary/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSongLibraries();
      return response['hydra:member'] || response;
    } catch (error) {
      return rejectWithValue(error || 'Failed to fetch song libraries');
    }
  }
);

export const fetchSongLibrary = createAsyncThunk(
  'songLibrary/fetchOne',
  async (id, { rejectWithValue }) => {
    try {
      return await getSongLibrary(id);
    } catch (error) {
      return rejectWithValue(error || 'Failed to fetch song library');
    }
  }
);

const extractErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (Array.isArray(error)) {
    return error.map(e => e.message || e).join(', ');
  }
  if (error?.message) return error.message;
  if (error?.violations && Array.isArray(error.violations)) {
    return error.violations.map(v => v.message).join(', ');
  }
  return 'An error occurred';
};

export const addSongLibrary = createAsyncThunk(
  'songLibrary/create',
  async (data, { rejectWithValue }) => {
    try {
      return await createSongLibrary(data);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const editSongLibrary = createAsyncThunk(
  'songLibrary/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return await updateSongLibrary(id, data);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const importSongLibraryFromCsv = createAsyncThunk(
  'songLibrary/importCsv',
  async ({ id, file }, { rejectWithValue }) => {
    try {
      return await importSongLibraryCsv(id, file);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const removeSongLibrary = createAsyncThunk(
  'songLibrary/delete',
  async (id, { rejectWithValue }) => {
    try {
      await deleteSongLibrary(id);
      return id;
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);
